import PropTypes from 'prop-types';
import merge from 'lodash/merge';

import Chart from '../../charts/Chart';

import { barChartConfiguration } from './utilities/helpers';

const BarChart = ({ onChartCallback, series, xAxis, yAxis, ...props }) => {
  return (
    <Chart
      onChartCallback={onChartCallback}
      options={merge({}, barChartConfiguration, { series, type: 'bar', xAxis, yAxis, ...props })}
      {...props}
    />
  );
};

BarChart.propTypes = {
  onChartCallback: PropTypes.func,
  series: PropTypes.array,
  xAxis: PropTypes.object,
  yAxis: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default BarChart;
